module.exports = __webpack_public_path__ + "static/media/lend_trx.c9e666c6.svg";